/** Shared "all organizations" sentinel used by the bull filter form. */
export const allOrganizationsValue = -1;
